import { render, staticRenderFns } from "./McmWallet.vue?vue&type=template&id=50723174&scoped=true"
import script from "./McmWallet.vue?vue&type=script&lang=js"
export * from "./McmWallet.vue?vue&type=script&lang=js"
import style0 from "./McmWallet.vue?vue&type=style&index=0&id=50723174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50723174",
  null
  
)

export default component.exports